export enum AssessmentCollaborationState {
    None = 'None',
    Shared = 'Shared',
    Submitted = 'Submitted'
}

export enum AssessmentColumnEnum {
    BusinessUnit = 'businessUnit',
    Collaborators = 'collaborators',
    CollabCompleted = 'collabCompleted',
    CollaborationStatus = 'collaborationStatus',
    DataSources = 'dataSources',
    DataSubjects = 'dataSubjects',
    Labels = 'labels',
    Name = 'name',
    ReviewDate = 'reviewDate',
    Status = 'status',
    Type = 'type',
    Owner = 'owner',
    Creator = 'creator',
    CreatedDate = 'createdDate',
    LastUpdate = 'lastUpdate',
    StatusChangeDate = 'statusChangeDate'
}

export enum AssessmentInviteeStatusEnum {
    Expired = 'Expired',
    Invited = 'Invited',
    Revoked = 'Revoked'
}

/**
 * Section visibility (`DevSectionVisibility`): the access scope granted to a collaborator on invite.
 * `VisibleSections` (default) hides sections marked hidden-from-collaborators; `AllSections` shows
 * everything. Enforcement is server-side.
 */
export enum CollaboratorVisibilityScopeEnum {
    VisibleSections = 'VisibleSections',
    AllSections = 'AllSections',
}

export enum AssessmentQuestionTypeEnum {
    BusinessOwner = 'BusinessOwner',
    BusinessPurpose = 'BusinessPurpose',
    BusinessUnit = 'BusinessUnit',
    DropdownCustomField = 'DropdownCustomField',
    TextCustomField = 'TextCustomField',
    DataFlow = 'DataFlow',
    DataRole = 'DataRole',
    DataSources = 'DataSources',
    DataSubjects = 'DataSubjects',
    DataTypes = 'DataTypes',
    Datepicker = 'DatePicker',
    DpiaNeeded = 'DpiaNeeded',
    Dropdown = 'Dropdown',
    File = 'File',
    LegalBasis = 'LegalBasis',
    LinkedAssessment = 'LinkedAssessment',
    PartiesWithAccess = 'PartiesWithAccess',
    Risks = 'Risks',
    ShortAnswer = 'ShortAnswer',
    Text = 'Text',
    TextBlock = 'TextBlock',
    Textarea = 'Textarea',
    TransferMechanism = 'TransferMechanism',

    Group = 'group', // deprecated - remove after v4 migration
    NewSection = 'new-section', // deprecated - remove after v4 migration
    CustomComponent = 'custom-component', // deprecated - remove after v4 migration
}

export enum AssessmentStatusEnum {
    Completed = 'Completed',
    Draft = 'Draft',
    InProgress = 'InProgress',
    Reject = 'Reject',
}

export enum AssessmentTemplateEnum {
    ADMT_CCPA = 'ADMT-CCPA',
    AI = 'AI',
    AI_EU = 'AI-EU',
    AI_RISK_MODEL_DEVELOPER_FOCUSED = 'AI-Risk-Model-Developer-Focused',
    COPPA = 'COPPA',
    DORA_ICT_THIRD_PARTY_CRITICALITY = 'DORA-ICT-Third-Party-Criticality',
    DPIA = 'DPIA',
    DPIA_CCPA = 'DPIA-CCPA',
    DPIA_Canada = 'DPIA-Canada',
    DPIA_Simplified_ICO = 'DPIA-Simplified-ICO',
    DPIA_Standard_GDPR_V2 = 'DPIA-Standard-GDPR-V2',
    EDPB_DPIA = 'EDPB-DPIA',
    Empty = 'Empty',
    ESG = 'ESG',
    HIPAA = 'HIPAA',
    LIA = 'LIA',
    MULTI_FRAMEWORK_VENDOR_ASSESSMENT = 'Multi-Framework-Vendor-Assessment',
    NIS2 = 'NIS2',
    NIST_CSF_RISK = 'NIST-CSF-Risk',
    OFFBOARDING = 'Offboarding',
    PA = 'PA',
    PCI_DSS = 'PCI-DSS',
    PIA = 'PIA',
    REASSESSMENT = 'Reassessment',
    ROI = 'ROI',
    THIRD_PARTY_DPIA = 'Third-Party-DPIA',
    TIA = 'TIA',
    Vendor = 'Vendor'
}

export enum DataFlowNodeTypeEnum {
    System = 'System',
    CustomEntity = 'CustomEntity'
}

export enum AssessmentEditOpEnum {
    Replace = 'replace'
}

export enum UserType {
    Agent = 'Agent',
    Collab = 'Collab',
    AiAgent = 'AiAgent',
}

export enum AssessmentActivityLogType {
    Assessment = 'Assessment',
    Section = 'Section',
    Question = 'Question',
}

export enum AssessmentActivityLogActionType {
    Added = 'Added',
    Removed = 'Removed',
    Updated = 'Updated',
}

export enum AssessmentActivityLogFieldChangeType {
    State = 'State',
    Name = 'Name',
    Label = 'Label',
    OwnerId = 'OwnerId',
    SectionOwnerId = 'SectionOwnerId',
    TagIds = 'TagIds',
    Ordinality = 'Ordinality',
    Value = 'Value',
    Description = 'Description',
    ReviewReminder = 'ReviewReminder',
    Clone = 'Clone',
    VersionRestore = 'VersionRestore',
    Collaborator = 'Collaborator',
    CollaborationSubmit = 'CollaborationSubmit',
    CollaborationLock = 'CollaborationLock',
    CollaborationMarkDone = 'CollaborationMarkDone',
    CollaborationMarkDoneForAll = 'CollaborationMarkDoneForAll',
    AutofillTriggered = 'AutofillTriggered',
    AutofillSuggestion = 'AutofillSuggestion',
    FormSubmissionAttachment = 'FormSubmissionAttachment',
    CollaboratorVisibilityScope = 'CollaboratorVisibilityScope',
}
